import OrderSummary from "./OrderSummary";
import ProductCart from "./ProductCart";
import "./cart.css";
import * as cart from "../../network/api/cart";
import { getProductsOfCart } from "../../network/api/product";
import { update } from "../../network/api/personal_cookies";
import { useEffect, useState } from "react";
import { products } from "../subcatigory/SubcardsSide/data";
import { useTranslation } from "react-i18next";
import EmpityCart from "./EmpityCart";
import PopUp from "../room/PopUp.jsx";
import FreeCart from "./freecarts/FreeCart.jsx";
import ProductInCart from "./ProductInCart.jsx";
import {
  getFees,
  getShippingExpenses,
} from "../../network/api/ShippingFees.js";
import axios from "axios";
import { link } from "../../config.js";

function Cart(props) {
  const { t } = useTranslation();
  const [VRactive, setVRactive] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [cartItems, setCartItems] = useState([]);
  const [ProductItems, setProductItems] = useState([]);
  const [isCartEmpty, setIsCartEmpty] = useState(true);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [fees, setFees] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);
  const [shippingExpenses, setShippingExpenses] = useState(0);
  const [coupon, setCoupon] = useState(null);
  const [shippingType, setShippingType] = useState("");

  const [taxFalt, setTaxFlat] = useState(0);

  useEffect(() => {
    const fetchShippingExpenses = async () => {
      try {
        const { data } = await axios.get(`${link}shipping-control`);
        setShippingType(data.data.name);
      } catch (error) {
        console.log(error);
      }
    };

    fetchShippingExpenses();
  }, []);

  const load = async () => {
    let siteWideDiscount = null;
    try {
      const { data } = await axios.get(`${link}site-wide-discount`);
      siteWideDiscount = data.siteWideDiscount;
    } catch (error) {
      console.log(error);
    }
  
    const productArr = [];
    const cartArr = await cart.get_cart();
  
    if (cartArr?.length === 0) {
      setIsCartEmpty(true);
      return;
    } else {
      setIsCartEmpty(false);
    }
  
    let quantities = 0;
    cartArr?.forEach((element) => {
      productArr.push(element.product_id);
      quantities += element.quantity;
    });
  
    const products = await getProductsOfCart(productArr);
    setCartItems(cartArr);
    setProductItems(products);
  
    let total = 0;
    let totalShippingCost = 0;
    let taxFlat = 0;
    let totalDiscountToday = 0;
    let totalDiscountFlash = 0;
  
    const getShippingExpenses = async () => {
      if (shippingType === "order") {
        const { data: shippingCostOrder } = await axios.get(
          `${link}order-flat-rate`
        );
        totalShippingCost = shippingCostOrder?.flatRate || 0;
      } else if (shippingType === "vendor") {
        const { data: shippingCostVendor } = await axios.get(
          `${link}vendor-flat`
        );
        totalShippingCost = shippingCostVendor?.cost || 0;
      }
      setShippingExpenses(totalShippingCost);
    };
  
    await getShippingExpenses();
  
    products?.forEach((element, index) => {
      let productDiscount = element.price_before * (element.discount / 100);
      let priceAfterDiscount = element.price_before - productDiscount;
  
      let siteWideDiscountValue = 0;
      if (siteWideDiscount) {
        if (siteWideDiscount.discountFlatRateActive) {
          siteWideDiscountValue = siteWideDiscount.discountFlatRate;
        } else if (siteWideDiscount.discountPercentageActive) {
          siteWideDiscountValue =
            element.price_before * (siteWideDiscount.discountPercentage / 100);
        }
      }
  
      if (siteWideDiscountValue > productDiscount) {
        priceAfterDiscount = element.price_before - siteWideDiscountValue;
      }
  
      if (
        coupon?.type === "product" &&
        coupon.products?.includes(element._id)
      ) {
        if (coupon.discountPercentageProduct) {
          priceAfterDiscount -=
            (priceAfterDiscount * coupon.discountPercentageProduct) / 100;
        } else if (coupon.discountFlatRateProduct) {
          priceAfterDiscount -= coupon.discountFlatRateProduct;
        }
      }
  
      priceAfterDiscount = Math.max(priceAfterDiscount, 0);
  
      total += priceAfterDiscount * cartArr[index].quantity;
  
      if (shippingType === "product") {
        totalShippingCost +=
          (element.shipping_cost || 0) * cartArr[index].quantity;
        taxFlat += (element.tax_Flat || 0) * cartArr[index].quantity;
      } else if (shippingType === "vendor") {
        // Only calculate shipping and tax for products with a valid supplierVendor
        if (element.supplierVendor !== null) {
          totalShippingCost +=
            (element.shipping_cost || 0) * cartArr[index].quantity;
          taxFlat += (element.tax_Flat || 0) * cartArr[index].quantity;
        }
      }
  
      const todayDiscountTotal = (element?.todayDiscount || []).reduce(
        (sum, discount) => sum + discount.discount,
        0
      );
      totalDiscountToday += todayDiscountTotal * cartArr[index].quantity;
  
      const flashDiscountTotal = (element?.flashDiscount || []).reduce(
        (sum, discount) => sum + discount.discount,
        0
      );
      totalDiscountFlash += flashDiscountTotal * cartArr[index].quantity;
    });
  
    if (coupon?.type === "order" && total >= coupon.minShoppingValueOrder) {
      if (coupon.discountPercentageOrder) {
        total -= (total * coupon.discountPercentageOrder) / 100;
      } else if (coupon.discountFlatRateOrder) {
        total -= coupon.discountFlatRateOrder;
      }
  
      total = Math.max(total, 0);
  
      if (coupon.maxShoppingValueOrder) {
        total = Math.min(total, coupon.maxShoppingValueOrder);
      }
    }
  
    setTotalPrice(total - totalDiscountToday - totalDiscountFlash);
    setTotalQuantity(quantities);
    setFees(taxFlat);
    setShippingExpenses(totalShippingCost); // Update shipping expenses
    props.update_p();
  };

  useEffect(() => {
    load();
  }, [coupon, shippingType]);

  useEffect(() => {
    setFinalPrice(totalPrice + fees + shippingExpenses);
  }, [totalPrice, fees, shippingExpenses]);

  return (
    <section className="products-cart">
      <div className="container">
        <div className="head-title">
          <p className="m-0">{t("home")}</p>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5781 3.4001L7.14479 8.83343C6.50312 9.4751 6.50312 10.5251 7.14479 11.1668L12.5781 16.6001"
              stroke="#807D7E"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p className="m-0">{t("chart")}</p>
        </div>
        {isCartEmpty ? (
          <FreeCart />
        ) : (
          <div className="d-flex flex-column flex-lg-row align-items-center">
            <div className="flex-grow-1 align-self-stretch summary">
              <h3 className="summary-title">
                {t("Order Summary")}{" "}
                <span>
                  ( {ProductItems.length} {t("products")} )
                </span>
              </h3>
              {ProductItems?.map((product, index) => (
                <ProductInCart
                  key={index}
                  cart={cartItems[index]}
                  personal={props.personal}
                  product={product}
                  load={load}
                  update_p={props.update_p}
                />
              ))}
            </div>
            <OrderSummary
              cartItems={cartItems}
              totalPrice={totalPrice}
              finalPrice={finalPrice}
              shippingExpenses={shippingExpenses}
              fees={fees}
              totalQuantity={totalQuantity}
              setCoupon={setCoupon}
            />
          </div>
        )}
      </div>
    </section>
  );
}
export default Cart;
